import { useMemo } from 'react';
import useTable from '@/hooks/useTable';
import type { GsStory } from '@/lib/types';
import ArticleCard from './ArticleCard';

export default function RelatedStories({ category, excludeId }: { category: string; excludeId: number }) {
  const { data: stories } = useTable<GsStory>('gs_stories');

  const related = useMemo(() => {
    const sameCategory = stories.filter((s) => s.id !== excludeId && s.category === category);
    const others = stories.filter((s) => s.id !== excludeId && s.category !== category);
    return [...sameCategory, ...others].slice(0, 3);
  }, [stories, category, excludeId]);

  if (related.length === 0) return null;

  return (
    <section className="bg-background-100 px-4 md:px-8 py-14 md:py-20 border-t border-background-200">
      <p className="font-label uppercase tracking-[0.28em] text-xs text-primary-600 font-semibold">Keep reading</p>
      <h2 className="font-heading font-bold text-3xl md:text-5xl text-foreground-950 leading-[1.02] mt-3 mb-10">Related stories</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {related.map((s) => <ArticleCard key={s.id} story={s} />)}
      </div>
    </section>
  );
}